import { Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { ExtendedBackgroundTitle, LightBackground, LightCard } from "../../../../Constants/Constants";

const ExtendedBackground = () => {
  return (
    <Col xl="4" sm="12">
      <div className="border-wrapper h-100 border">
        <H6 className="mb-3">{ExtendedBackgroundTitle}</H6>
        <div className="helper-common-box">
          <div className="helper-box light-card" />
          <span>{LightCard}</span>
        </div>
        <div className="helper-common-box">
          <div className="helper-box light-background border" />
          <span>{LightBackground}</span>
        </div>
      </div>
    </Col>
  );
};
export default ExtendedBackground;
